<template>
  <div class="pane_con">
    <el-input
      style="margin-bottom: 10px"
      v-model="username"
      placeholder="请输入用户名"
      prefix-icon="el-icon-s-custom"
    ></el-input>
    <el-input
      style="margin-bottom: 10px"
      placeholder="请输入密码"
      v-model="password"
      @keyup.enter.native="login"
      show-password
      prefix-icon="el-icon-lock"
    ></el-input>
    <!-- <div class="micode">
      <el-input type="text" v-model="codes" class="verify_input" id="user-codes" title="请输入验证码" placeholder="请输入验证码">
      </el-input>
      <div id="verify"></div>
    </div> -->
    <!-- <div class="forget" style="margin-bottom:10px;">
      <span @click="reset">忘记密码</span>
    </div> -->
    <!-- <div class="pasbox">
      <el-checkbox v-model="checked">记住密码</el-checkbox> -->
    <!-- <div>忘记密码?</div> -->
    <!-- </div> -->
    <el-button style="width: 100%" type="success" @click="login"
      >登录</el-button
    >
    <!-- <div class="nolog" @click="touristLogin">暂不登录，以游客身份查看资讯</div> -->
  </div>
</template>


<script>
import { GVerify } from "../../gVerify/gVerify.js";
export default {
  created() {
    if (this.$route.query.name && this.$route.query.password) {
      this.username = this.$route.query.name;
      this.username = this.$route.query.name;
      this.bool = false;
      let obj = {
        condition: {
          account: this.username,
          password: this.password,
        },
      };

      this.$api
        .login(obj)
        .then((res) => {
          this.bool = true;
          if (res.data.success) {
            this.$message({
              message: "登录成功",
              type: "success",
            });
            sessionStorage.setItem(
              "electronicPublicationStatus",
              res.data.data.electronicPublicationStatus
            );
            sessionStorage.setItem("token", res.data.data.loginName);
            sessionStorage.setItem("hospitalName", res.data.data.realName);
            sessionStorage.setItem("telephone", res.data.data.telephone);
            sessionStorage.setItem("isLogin", 1);
            this.$router.push("/index");
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  },
  data() {
    return {
      // checked: false,
      username: "",
      password: "",
      //节流开关变量
      bool: true,
      codes: "",
      verifyCode: null,
    };
  },
  mounted() {
    // this.verifyCode = new GVerify('verify');
  },
  methods: {
    // reset() {
    //   this.$emit("set", 2);
    // },
    async login() {
      if (this.username === "") {
        this.$message.error("请输入用户名");
      } else if (this.password === "") {
        this.$message.error("请输入密码");
      } else {
        //ajax请求
        this.bool = false;
        let obj = {
          account: this.username,
          password: this.password,
        };
        try {
          await this.$store.dispatch("user/login", obj);
          await this.$store.dispatch("user/getUserInfo");
          this.$router.push("/index");
          this.$message({
            message: "登录成功",
            type: "success",
          });
          sessionStorage.removeItem("isLogin");
          sessionStorage.setItem("isLogin", 1);
        } catch (err) {
          // this.verifyCode = new GVerify("verify");
          // console.log(err.message);
          // this.$message.error(err.message);
        }

        // this.$api.
        //   .login(obj)
        //   .then((res) => {
        //     this.bool = true;
        //     if (res.data.success) {
        //       this.$message({
        //         message: "登录成功",
        //         type: "success",
        //       });
        //       console.log(res);
        //       // sessionStorage.setItem(
        //       //   "electronicPublicationStatus",
        //       //   res.data.data.electronicPublicationStatus
        //       // );

        //       sessionStorage.setItem("token", res.data.data);
        //       // sessionStorage.setItem("hospitalName", res.data.data.realName);
        //       // sessionStorage.setItem("telephone", res.data.data.telephone);
        //       // sessionStorage.setItem("isLogin", 1);
        //       // sessionStorage.removeItem("isLogin1");
        //     } else {
        //       this.verifyCode = new GVerify("verify");
        //       this.$message.error(res.data.message);
        //     }
        //   })
        //   .catch((err) => {
        //     this.verifyCode = new GVerify("verify");
        //     console.log(err);
        //   });
      }
    },
    touristLogin() {
      sessionStorage.setItem("isLogin1", 1);
      this.$router.push("/index");
    },
  },
};
</script>

<style scoped>
.forget span {
  font-size: 14px;
  color: #fff;
  float: right;
  margin-right: 3rem;
  margin-top: 0.1rem;
  cursor: pointer;
}
.pasbox {
  width: 92%;
  display: flex;
  justify-content: space-between;
}
.pasbox div {
  color: rgba(11, 112, 193, 1);
  cursor: pointer;
}
.nolog {
  color: rgba(11, 112, 193, 1);
  cursor: pointer;
  text-align: center;
  margin-top: 10px;
}
.pane_con {
  /* position: relative;
  top: 119px;
  background: rgba(255, 255, 255, 0.2);
  width: 400px; */
  padding: 80px 30px 10px 30px;
  /* margin: -0.58rem;
  margin-left: -10px;
  border-top-right-radius: 10px; */
}

.el-input__inner {
  height: 45px;
}

.el-button--success {
  margin-top: 90px;
  color: #fff;
  background: rgba(11, 112, 193, 1);
  border-color: rgba(11, 112, 193, 1);
}

.el-button--success:focus {
  background: rgba(11, 112, 193, 1);
}

.el-button--success:hover {
  background: rgba(11, 112, 193, 1);
}

.micode {
  width: 310px;
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  position: relative;
}

.micode .verify_input {
  width: 100%;
}

#verify {
  width: 130px;
  height: 40px;
  position: absolute;
  right: 0;
  top: 0;
}

#verifyCanvas {
  height: 40px;
}

.micode /deep/ .el-input .el-input__inner {
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
}
</style>